import { render } from "./ProductOptionsTable.vue?vue&type=template&id=1444187a&scoped=true"
import script from "./ProductOptionsTable.vue?vue&type=script&lang=js"
export * from "./ProductOptionsTable.vue?vue&type=script&lang=js"

import "./ProductOptionsTable.vue?vue&type=style&index=0&id=1444187a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Sebastian\\Desktop\\-taptasty-order\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1444187a"]])

export default __exports__